import http from "@/api/request";
import { AGENT_SERVICE_BASE } from "@/config/apiBaseUrlConfig";

import type {
  AgentCreateRequest,
  AgentDetailVO,
  AgentPageQueryRequest,
  AgentUpdateRequest,
  PageDataAgentPageItemVO,
} from "./type";

/**
 * 分页查询代理列表
 * GET /service-chijing-agent/api/agent/getPage
 * @param params 分页与筛选条件
 */
export const getAgentPage = (params: AgentPageQueryRequest) => {
  return http.get<PageDataAgentPageItemVO>(`${AGENT_SERVICE_BASE}/getPage`, { params });
};

/**
 * 新增代理
 * POST /service-chijing-agent/api/agent/addAgent
 * @param data 代理创建参数
 */
export const addAgent = (data: AgentCreateRequest) => {
  return http.post<number>(`${AGENT_SERVICE_BASE}/addAgent`, data);
};

/**
 * 查询代理详情
 * GET /service-chijing-agent/api/agent/getAgent/{id}
 * @param id 代理 ID
 */
export const getAgentDetail = (id: string) => {
  return http.get<AgentDetailVO>(`${AGENT_SERVICE_BASE}/getAgent/${id}`);
};

/**
 * 编辑代理
 * PUT /service-chijing-agent/api/agent/updateAgent/{id}
 * userId / businessEntityId 传 null 表示解绑对应侧；两者均为 null 时删除绑定
 * @param id 代理 ID
 * @param data 编辑参数
 */
export const updateAgent = (id: string, data: AgentUpdateRequest) => {
  return http.put<AgentDetailVO>(`${AGENT_SERVICE_BASE}/updateAgent/${id}`, data);
};
